import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react"
import { Component } from "@/types/types"
import { BrandMark } from "@/ui/atoms/branding/BrandMark"
import { TextLink } from "@/ui/atoms/controls/TextLink"
import { Icon } from "@/ui/atoms/media/Icon"
import { Stack } from "@/ui/atoms/layout/Stack"
import { MarketingSection } from "@/ui/blocks/layout/MarketingSection"
import { cx } from "@/utils/cx"
import { ThemeProvider } from "@/ui/providers/ThemeProvider"

export interface Props extends Component {
  useDarkTheme?: boolean
}

export function MarketingNav({ className = "", useDarkTheme = false }: Props) {
  return (
    <div className={cx(`relative`, className)}>
      <nav className="z-1 z-10">
        <MarketingSection removeYPadding removeXPadding>
          <div className="flex items-center justify-between py-10 relative">
            <TextLink
              href="/"
              className="inline-block align-middle focus-ring--on-global-header"
              testId="brandLink"
            >
              <BrandMark theme={useDarkTheme ? "dark" : "light"} className="w-[224px] h-auto" />
            </TextLink>

            <div className="flex items-center gap-10 shrink-0">
              <TextLink
                href="/sign-in"
                className="text-text focus-ring--on-global-header block"
                testId="signInLink"
                style="bold"
              >
                Sign in
              </TextLink>
            </div>
          </div>
        </MarketingSection>
      </nav>
    </div>
  )
}
